import { POSITION } from '@/utils/constants';
import { normalizeDepartments } from '@/utils/helper';
import {
  get, post, patch, del, put,
} from './helper';

// NOTE: WITH member count and total member count
const getDepartments = async () => {
  const res = await get({
    url: 'admin/departments',
    version: 1,
  });

  const { departments: data = [], total = 0 } = res?.data || res || {};

  const currentMemberSum = data.reduce(
    (sum, department) => sum + (department.member_count || 0), 0,
  );
  const remainingCount = Math.max(0, total - currentMemberSum);

  const departments = normalizeDepartments(data, {
    position: POSITION.END,
    additionalProps: { member_count: remainingCount },
  });

  return { departments };
};

// NOTE: WITHOUT member count and total member count
const getDepartmentList = async () => {
  const res = await get({
    url: 'team/departments',
    version: 0,
  });
  const { departments: data } = res?.data || res || {};
  const departments = normalizeDepartments(data);
  return { departments };
};

const createDepartment = async (data) => {
  const res = await post({
    url: 'team/departments',
    data,
    version: 0,
  });
  return res?.data || res;
};

const removeDepartment = async (departmentId) => {
  const res = await del({
    url: `team/departments/${departmentId}`,
    version: 0,
  });
  return res?.data || res;
};

const getTeamInfo = async () => {
  const res = await get({
    url: 'user/current_team',
    version: 0,
  });
  return res?.data || res;
};

const updateTeamInfo = async (data) => {
  const res = await patch({
    url: 'team',
    data,
    version: 0,
  });
  return res?.data || res;
};

const updateDepartmentInfo = async (data) => {
  const res = await put({
    url: 'team/departments/batch_update',
    data,
    version: 0,
  });
  return res?.data || res;
};

const contact = async (data) => {
  const res = await post({
    url: 'email/contact_us',
    data,
    version: 0,
  });
  return res?.data || res;
};

const upgrade = async (data) => {
  /* const r =  await post({
    url: 'team/upgrade',
    data,
  });
  return res?.data || res; */
  console.log(data);
  return new Promise((resolve) => {
    setTimeout(resolve, 1000);
  });
};

export default {
  contact,
  createDepartment,
  getDepartmentList,
  getDepartments,
  getTeamInfo,
  removeDepartment,
  updateDepartmentInfo,
  updateTeamInfo,
  upgrade,
};
